import React from 'react';

interface DocsIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const DocsIcon: React.FC<DocsIconProps> = ({ 
  width = 16, 
  height = 16, 
  className = "" 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_112_47234)">
        <path 
          d="M10.5 4.25C10.6658 4.25 10.8247 4.31585 10.9419 4.43306C11.0592 4.55027 11.125 4.70924 11.125 4.875C11.125 5.04076 11.0592 5.19973 10.9419 5.31694C10.8247 5.43415 10.6658 5.5 10.5 5.5H5.5C5.33424 5.5 5.17527 5.43415 5.05806 5.31694C4.94085 5.19973 4.875 5.04076 4.875 4.875C4.875 4.70924 4.94085 4.55027 5.05806 4.43306C5.17527 4.31585 5.33424 4.25 5.5 4.25H10.5ZM15.3169 15.3169C15.1997 15.434 15.0407 15.4999 14.875 15.4999C14.7093 15.4999 14.5503 15.434 14.4331 15.3169L12.9288 13.8125C12.4832 14.0968 11.966 14.2486 11.4375 14.25C10.8812 14.25 10.3375 14.085 9.87496 13.776C9.41245 13.467 9.05196 13.0277 8.83909 12.5138C8.62622 11.9999 8.57052 11.4344 8.67904 10.8888C8.78756 10.3432 9.05543 9.8421 9.44876 9.44876C9.8421 9.05543 10.3432 8.78756 10.8888 8.67904C11.4344 8.57052 11.9999 8.62622 12.5138 8.83909C13.0277 9.05196 13.467 9.41245 13.776 9.87496C14.085 10.3375 14.25 10.8812 14.25 11.4375C14.2486 11.966 14.0968 12.4832 13.8125 12.9288L15.3169 14.4331C15.434 14.5503 15.4999 14.7093 15.4999 14.875C15.4999 15.0407 15.434 15.1997 15.3169 15.3169ZM11.4375 13C11.7465 13 12.0486 12.9084 12.3056 12.7367C12.5625 12.565 12.7628 12.321 12.8811 12.0354C12.9993 11.7499 13.0303 11.4358 12.97 11.1327C12.9097 10.8296 12.7609 10.5512 12.5424 10.3326C12.3238 10.1141 12.0454 9.96531 11.7423 9.90502C11.4392 9.84473 11.1251 9.87568 10.8396 9.99394C10.554 10.1122 10.31 10.3125 10.1383 10.5694C9.96664 10.8264 9.875 11.1285 9.875 11.4375C9.875 11.8519 10.0396 12.2493 10.3326 12.5424C10.6257 12.8354 11.0231 13 11.4375 13ZM8.625 14.25H4.875C4.37772 14.25 3.90081 14.0525 3.54917 13.7008C3.19754 13.3492 3 12.8723 3 12.375V3.625C3 3.12772 3.19754 2.65081 3.54917 2.29917C3.90081 1.94754 4.37772 1.75 4.875 1.75H12.375C12.5408 1.75 12.6997 1.81585 12.8169 1.93306C12.9342 2.05027 13 2.20924 13 2.375V7.375C13 7.54076 13.0658 7.69973 13.1831 7.81694C13.3003 7.93415 13.4592 8 13.625 8C13.7908 8 13.9497 7.93415 14.0669 7.81694C14.1842 7.69973 14.25 7.54076 14.25 7.375V2.375C14.25 1.87772 14.0525 1.40081 13.7008 1.04917C13.3492 0.697544 12.8723 0.5 12.375 0.5L4.875 0.5C4.0465 0.500992 3.25222 0.830551 2.66639 1.41639C2.08055 2.00222 1.75099 2.7965 1.75 3.625V12.375C1.75099 13.2035 2.08055 13.9978 2.66639 14.5836C3.25222 15.1694 4.0465 15.499 4.875 15.5H8.625C8.79076 15.5 8.94973 15.4342 9.06694 15.3169C9.18415 15.1997 9.25 15.0408 9.25 14.875C9.25 14.7092 9.18415 14.5503 9.06694 14.4331C8.94973 14.3158 8.79076 14.25 8.625 14.25Z" 
          fill="#939393"
        />
      </g>
      <defs>
        <clipPath id="clip0_112_47234">
          <rect width="15" height="15" fill="white" transform="translate(0.5 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default DocsIcon;
